/**
 * Minimal replacement for Bootstrap's collapse plugin. It supports `data-bs-toggle="collapse"`
 * triggers that point at a panel with `href="#id"` or `data-bs-target="#id"`, toggling the panel's
 * `show` class and keeping the `collapsed` class and `aria-expanded` of every trigger for that panel in sync.
 *
 * Listening on the document means triggers created at runtime work, and it runs after any handler on the
 * trigger itself (for example, those that clear `show` from sibling panels first), as Bootstrap's did.
 * Panels show and hide instantly (there is no height animation).
 */
const TRIGGER_SELECTOR = '[data-bs-toggle="collapse"]';

const getTargetSelector = (trigger) => trigger.dataset.bsTarget || trigger.getAttribute('href');

export default function initCollapse() {
	document.addEventListener('click', (event) => {
		const trigger = event.target.closest(TRIGGER_SELECTOR);
		if (!trigger) {
			return;
		}

		const selector = getTargetSelector(trigger);
		if (!selector || !selector.startsWith('#')) {
			return;
		}

		const panel = document.getElementById(selector.slice(1));
		if (!panel) {
			return;
		}

		if (trigger.tagName === 'A') {
			event.preventDefault();
		}

		const shown = panel.classList.toggle('show');

		document.querySelectorAll(TRIGGER_SELECTOR).forEach((item) => {
			if (getTargetSelector(item) === selector) {
				item.classList.toggle('collapsed', !shown);
				item.setAttribute('aria-expanded', String(shown));
			}
		});
	});
}
